import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostsInfoComponent } from './posts-info.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  { path: '', component: PostsInfoComponent, data: { title: 'Información de posts' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PostsInfoRoutingModule { }
